var ProUpgrade = function() {

    var _watch = function( content ){

        $('#join-waitlist').off().on('show.bs.modal',function(){
            $('input[name="waitlist-email"]').val('');
            $('#waitlist-inputs').addClass('d-block').removeClass('d-none');
            $('#waitlist-close').addClass('d-none').removeClass('d-flex');
            $('#waitlist-setup').addClass('d-block').removeClass('d-none');
            $('#waitlist-confirmed').addClass('d-none').removeClass('d-block');
            $('#waitlist-email-confirm-text').empty();
        });

        $('#waitlist-submit').off().on('click',function(){
            _doAjax('/pro/upgrade/waitlist',{
                email: $('input[name="waitlist-email"]').val()
            });
        });

    }

    return {
        watch: function( c ){
            _watch( c );
        },
    }

}();

var paintWatchlist = function( response ){
    $('#waitlist-inputs').addClass('d-none').removeClass('d-block');
    $('#waitlist-close').addClass('d-flex').removeClass('d-none').on('click',function(){
        $('#join-waitlist').modal('hide');
    });
    $('#waitlist-confirmed').addClass('d-block').removeClass('d-none');
    $('#waitlist-setup').addClass('d-none').removeClass('d-block');
    $('#waitlist-email-confirm-text').html(response.confirmtext);
    ProUpgrade.watch();
}